<style>
@import '../../assets/css/transaction.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                <form @submit.prevent="initialize" :submit="initialize">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_username')}}</template>
                        <el-input v-model="ajaxSearch.login" clearable></el-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" type="submit">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </form>
            </b-card>
            <b-card :header="$t($route.name)">
                <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                        <template slot="header">
                            <p>{{title.label}}</p>
                            <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                        </template>
                    </el-table-column>
                    <el-table-column type="expand">
                        <b-button variant="info" size="lg" @click="infoShoppingRecord()">{{$t('admin.table_check_details')}}</b-button>
                    </el-table-column>
                </el-table>
                <b-row class="mt-3">
                    <b-col sm="12" md="3" class="pr-0">
                        <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                    </b-col>
                    <b-col sm="12" md="9" class="pl-0">
                        <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                    </b-col>
                </b-row>
            </b-card>
            <b-modal id="infoShoppingRecord" :title="$t('admin.table_check_details')" hide-footer size="xl">
                <b-row class="form-label">
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_id')}}</template>
                            <label>{{ajaxInfo.id}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_date')}}</template>
                            <label>{{ajaxInfo.created_at}}</label>
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_completed_at')}}</template>
                            <label>{{ajaxInfo.completed_at}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <label>{{ajaxInfo.code}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_refer_code')}}</template>
                            <label>{{ajaxInfo.refer_code}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_username')}}</template>
                            <label>{{ajaxInfo.master_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_shopping_product_id')}}</template>
                            <label>{{ajaxInfo.shopping_product_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_shopping_payment_id')}}</template>
                            <label>{{ajaxInfo.shopping_payment_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_total_amount')}}</template>
                            <label>{{ajaxInfo.total_amount}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_original_amount')}}</template>
                            <label>{{ajaxInfo.original_amount}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_recharge_account')}}</template>
                            <label>{{ajaxInfo.recharge_account}}</label>                                                        
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_product_name')}}</template>
                            <label>{{ajaxInfo.product_name}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_product_detail_id')}}</template>
                            <label>{{ajaxInfo.product_detail_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_product_count')}}</template>
                            <label>{{ajaxInfo.product_count}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_ticket_code')}}</template>
                            <label>{{ajaxInfo.ticket_code}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_ticket_pass')}}</template>
                            <label>{{ajaxInfo.ticket_pass}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_ticket_url')}}</template>
                            <label style="word-break: break-all;">{{ajaxInfo.ticket_url}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_ticket_valid_at')}}</template>
                            <label>{{ajaxInfo.ticket_valid_at}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <label>{{ajaxInfo.status}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_shopping_status_id')}}</template>
                            <label>{{ajaxInfo.shopping_status_id}}</label>                                                        
                        </b-form-group>
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_remark')}}</template>
                            <label style="word-break: break-all;">{{ajaxInfo.remark}}</label>                                                        
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-modal>
        </div>
    </div>
</template>

<script>
import {shoppingRecordAjaxTable,shoppingRecordInfo} from '@/system/model/report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxToolList:[],
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',completed_at:'',shopping_product_id:'',code:'',refer_code:'',master_id:'',total_amount:'',status:'',shopping_status_id:'',login:''},
            ajaxRow:'',
            ajaxEdit:[],
            ajaxExportStart:'',
            ajaxExportEnd:'',
            statusList:[],
            showEdit: false,
            pageLimit:10,
            ajaxInfo:'',
            permission:{
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'50'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'200'
            },{
                prop: "completed_at",
                label: this.$t('admin.table_completed_at'),
                width:'200'
            },{
                prop: "shopping_product_id",
                label: this.$t('admin.table_shopping_product_id'),
                width:'200'
            },{
                prop: "code",
                label: this.$t('admin.table_code'),
                width:'180'
            },{
                prop: "refer_code",
                label: this.$t('admin.table_refer_code'),
                width:'180'
            },{
                prop: "master_id",
                label: this.$t('admin.table_user'),
                width:'180'
            },{
                prop: "total_amount",
                label: this.$t('admin.table_total_amount'),
                width:'130'
            },{
                prop: "status",
                label: this.$t('admin.table_status'),
                width:'100'
            },{
                prop: "shopping_status_id",
                label: this.$t('admin.table_shopping_status_id'),
                width:'100'
            }],        
        }
    },methods:{
        initialize(){
            var self = this;

            var result = shoppingRecordAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.completed_at,this.ajaxSearch.shopping_product_id,this.ajaxSearch.code,this.ajaxSearch.refer_code,this.ajaxSearch.master_id,this.ajaxSearch.total_amount,this.ajaxSearch.status,this.ajaxSearch.shopping_status_id,this.ajaxSearch.login);
            this.preloader(true);
            result.then(function(value){
                if(value.valid){
                    self.preloader(false);
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                    
                }else{
                    self.preloader(false);
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getToolList(){
            var self = this;
            var result = this.$general.getToolList();
            result.then(function(value){
                self.ajaxToolList = value.data;
            });
        },infoShoppingRecord(){
            var self = this;
            var result = shoppingRecordInfo(this.ajaxRow);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                self.$bvModal.show('infoShoppingRecord');
                if(value.valid){
                    self.ajaxInfo = value.data.this_detail;
                }
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id;
            this.showEdit = false;
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
        this.getToolList();
    }
}
</script>
